export const iconFontAwesomeEmojiFaceAngry = (
	<i className="fa-solid fa-face-angry"></i>
);
